import dom from 'embo/utils/dom'
import vsync from 'embo/utils/vsync'
import timer from 'embo/utils/timer'
import * as events from 'embo/utils/events'
import animate from 'embo/utils/animate'
import icon from './icon'
import {createSpinnerWave} from './spinner-wave'


const noop = () => {
}


export default class PageSpinner {
  constructor() {
    this.container = dom.el('div', {className: 'page-spinner'}, {display: 'none'})
    this.spinner = dom.parse(`
      <div class="spinner-wave spinner-wave--page">
        <svg class="spinner-wave__svg" viewBox="0 0 1200 80" preserveAspectRatio="none" aria-hidden="true">
          <path class="spinner-wave__path"></path>
        </svg>
      </div>
    `)[0]
    this.messageBox = dom.el('div', {className: 'page-spinner__msg'})
    this._wave = createSpinnerWave(this.spinner.querySelector('.spinner-wave__svg'))

    vsync.mutate(() => {
      this._setWaveState(false)
      this.container.appendChild(this.spinner)
      this.container.appendChild(this.messageBox)
      document.body.appendChild(this.container)
    })
  }

  show() {
    return vsync
      .mutate(() => this._setWaveState(false))
      .then(() => animate(this.container, 'fadeIn', {duration: 300, display: 'flex'}))
  }

  hide() {
    return animate(this.container, 'fadeOut', {duration: 200})
      .then(() => this._wave.stop())
  }

  /**
   * Shows an error message when an error cannot be resolved to an error page.
   *
   * @param {String|Error} msg
   * @param {Number} timeout
   *
   * @returns {Promise.<T>}
   */
  showFatalError(msg, timeout = 10000) {
    return vsync.mutate(() => {
      this.messageBox.innerHTML = `${icon('warning')} ${msg}`
      this.container.classList.add('page-spinner--has-error')
      this._setWaveState(true)
    })
      .then(() => events.one(this.container, 'click', timeout).catch(noop))
      .then(() => this.hide())
      .then(() => vsync.mutate(() => {
        this.messageBox.innerHTML = ''
        this.container.classList.remove('page-spinner--has-error')
        this._setWaveState(false)
      }))
  }

  /**
   * Displays spinner's error state during the time given by timeout.
   * Use before resolving an error to a valid error page.
   *
   * @param timeout
   * @returns {Promise.<T>}
   */
  showTransientError(timeout = 0) {
    return vsync.mutate(() => {
      this.container.classList.add('page-spinner--has-error')
      this._setWaveState(true)
    })
      .then(() => timer.delay(timeout))
      .then(() => this.hide())
      .then(() => vsync.mutate(() => {
        this.container.classList.remove('page-spinner--has-error')
        this._setWaveState(false)
      }))
  }

  _setWaveState(error) {
    this.spinner.classList.toggle('spinner-wave--error', error)
    if (error) {
      this._wave.stop()
    } else {
      this._wave.start()
    }
  }
}
